export const RankXP = [
  0, 10000, 20000, 40000, 80000, 160000, 196800, 242100, 297700, 366200, 450400,
  554100, 681500, 838200, 1081300, 1394900, 1799400, 2321200, 2994400, 3862800,
  5407900, 7571000, 10599400, 14839200, 20774900, 29084900, 40718800, 57006400,
  79808900, 111732500,
];

export const RankXPName = [
  "Nobody",
  "Apprentice",
  "Pickpocket",
  "Cloak",
  "Thief",
  "Locksmith",
  "Runner",
  "Associate",
  "Dealer",
  "Fixer",
  "Collector",
  "Enforcer",
  "Prospect",
  "Lieutenant",
  "Soldier",
  "Mobster",
  "Swindler",
  "Whisperer",
  "Architect",
  "Hitman",
  "Assassin",
  "Commander",
  "Executioner",
  "Widowmaker",
  "Bone collector",
  "Tactician",
  "Chief",
  "Warlord",
  "Capo bastone",
  "Godfather",
];

// Rank USD requirements (cumulative total required to reach each rank)
export const RankUSDRequirements = [
  0, // Rank 0: Nobody
  0, // Rank 1: Apprentice
  0, // Rank 2: Pickpocket
  5, // Rank 3: Cloak
  10, // Rank 4: Thief
  15, // Rank 5: Locksmith
  20, // Rank 6: Runner
  25, // Rank 7: Associate
  30, // Rank 8: Dealer
  35, // Rank 9: Fixer
  40, // Rank 10: Collector
  45, // Rank 11: Enforcer
  50, // Rank 12: Prospect
  55, // Rank 13: Lieutenant
  60, // Rank 14: Soldier
  65, // Rank 15: Mobster
  70, // Rank 16: Swindler
  75, // Rank 17: Whisperer
  80, // Rank 18: Architect
  85, // Rank 19: Hitman
  90, // Rank 20: Assassin
  95, // Rank 21: Commander
  100, // Rank 22: Executioner
  105, // Rank 23: Widowmaker
  110, // Rank 24: Bone collector
  115, // Rank 25: Tactician
  120, // Rank 26: Chief
  125, // Rank 27: Warlord
  130, // Rank 28: Capo bastone
  135, // Rank 29: Godfather
];

export const StakingStartRank = 3;
